import { render, staticRenderFns } from "./ProjectTaskTemplateDetailNewForm.vue?vue&type=template&id=9c90cb22"
import script from "./ProjectTaskTemplateDetailNewForm.vue?vue&type=script&lang=js"
export * from "./ProjectTaskTemplateDetailNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports